import Component from './message_queue_create.vue'
export default Component
